import React, { useEffect, useState } from "react";
import LGCrud from "../LGCrud";
import {
  addExpenseAccount,
  deleteExpenseAccount,
  getExpenseAccountList,
  updateExpenseAccount,
} from "../../api/accounting";
import { useCompany } from "../../contexts/CompanyContext";

export default function CrudExpenseAccounts() {
  const [expenseAccountsList, setExpenseAccountsList] = useState([]);
  const { selectedCompany } = useCompany();
  
  const fetchExpenseAccounts = async () => {
    const res = await getExpenseAccountList(selectedCompany.id);
    setExpenseAccountsList(res.data);
  };

  const handlePost = async (data) => {
    const payload = { ...data, companyId: selectedCompany.id };
    const res = await addExpenseAccount(payload);
  };

  const handleUpdate = async (id, data) => {
    const payload = { ...data, companyId: selectedCompany.id };
    const res = await updateExpenseAccount(id, payload);
  };

  const handleDelete = async (id) => {
    const res = await deleteExpenseAccount(id);
  };

  useEffect(() => {
    fetchExpenseAccounts();
  }, []);
  return (
    <LGCrud
      data={expenseAccountsList}
      columns={[
        {
          field: "name",
          headerName: "Nombre",
          flex: 0.5,
          editable: true,
        },
        {
          field: "contpaqiCode",
          headerName: "Cuenta Completa",
          flex: 0.5,
          editable: true,
        },
      ]}
      actionHandlers={{
        create: handlePost,
        update: handleUpdate,
        delete: handleDelete,
        fetchData: getExpenseAccountList,
      }}
    />
  );
}
